/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';

import { Heading } from 'sarsaparilla';

import LocationsListCard from './LocationsListCard';

const propTypes = {
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    onCardSelect: PropTypes.func,
    locations: PropTypes.array,
};

export function LocationsList(props) {
    if (!props.locations || props.locations.length === 0) {
        return null;
    }
    return (
        <div className="recommendation-list--outer">
            <Heading
                headingLevel={2}
                appearance="h6"
                className="rec-aside-body-heading mb-1 px-2 pb-half"
            >
                Explore Locations from this Story
            </Heading>

            <div className="ugc-story-nearby-list-wrap">
                {props.locations &&
                    props.locations.map((item, index) => {
                        if (index < 10) {
                            return (
                                <LocationsListCard
                                    key={item.entity_id}
                                    index={index}
                                    startDate={props.startDate}
                                    endDate={props.endDate}
                                    item={item}
                                    layout="campground"
                                    onCardSelect={props.onCardSelect}
                                />
                            );
                        }
                        return '';
                    })}
            </div>
        </div>
    );
}

LocationsList.propTypes = propTypes;

export default LocationsList;
